import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const navigate = useNavigate();
  return <section className="relative pt-20 pb-32 overflow-hidden bg-white" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-176">
        {/* Main Heading */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-gray-900 mb-8 max-w-4xl mx-auto leading-tight" data-id="element-177">
          Turn reconciliation into{' '}
          <span className="text-violet-600" data-id="element-178">confidence</span>
        </h1>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-179">
          Berry Finance automates transaction matching for small businesses —
          saving hours, catching anomalies, and eliminating errors.
        </p>

        {/* Email Capture Form */}
        <div className="max-w-md mx-auto  mb-8" data-id="element-180">
          <div className="flex flex-col gap-3" data-id="element-181">
            {/* <Input
             placeholder="Your work email"
             type="email"
             className="h-14 text-lg" /> */}


            <Button className="h-14 px-8 text-lg whitespace-nowrap"

          // onClick={() => navigate('/connect')}
          data-id="element-182">

              <a href="https://tally.so/r/D4dgqb" target="_blank" rel="noopener noreferrer" data-id="element-183">
              
                Get started for free
              </a> 
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 font-medium" data-id="element-184">
          <div className="flex items-center" data-id="element-185">
            <CheckCircle2 className="h-4 w-4 text-violet-600 mr-2" data-id="element-186" />
            Free 500 transactions
          </div>
          <div className="flex items-center" data-id="element-187">
            <CheckCircle2 className="h-4 w-4 text-violet-600 mr-2" data-id="element-188" />
            No credit card required
          </div>
          <div className="flex items-center" data-id="element-189">
            <CheckCircle2 className="h-4 w-4 text-violet-600 mr-2" data-id="element-190" />
            Cancel anytime
          </div>
        </div>
      </div>

      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-191">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-violet-50 blur-3xl opacity-60" data-id="element-192"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-blue-50 blur-3xl opacity-40" data-id="element-193"></div>
      </div>
    </section>;
}